import { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Grid, Container } from 'semantic-ui-react';

import { SuccessContainer } from '../../components';
import { APP_NAME } from '../../utils/constant';
import { INSTANCE_CONTACT_EMAIL } from '../../utils/instanceConstant';

import './auth.scss';

class AccountDisable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: null,
    };
  }

  componentDidMount() {
    const { t } = this.props;
    document.title = `${t('auth.pages.account_access')} | ${APP_NAME}`;
  }

  render() {
    const { t } = this.props;

    return (
      <Grid.Row>
        <Container className="email-verification-container">
          <SuccessContainer
            msg={t('auth.account.disabled.title')}
            description={[
              <span key="1">
                {t('auth.account.disabled.description.line1')}
              </span>,
              <br key="br" />,
              <span key="2">
                <Trans
                  i18nKey="auth.account.disabled.description.line2"
                  values={{ contactEmail: INSTANCE_CONTACT_EMAIL }}
                  components={{
                    1: (
                      <a
                        className="contactUs"
                        href={`mailto:${INSTANCE_CONTACT_EMAIL}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                  }}
                />
              </span>,
            ]}
            success={false}
            linkExpired={false}
          />
        </Container>
      </Grid.Row>
    );
  }
}

export default withTranslation()(AccountDisable);
